<template>
	<div class="honor">
		<div class="hn_box">
			<div class="hn_left">
				<div class="hn_box">
					<ul class="hn_ul" ref="listRef">
						<li class="hn_li" :class="actIndex == index ? 'ho_act1' : ''" v-for="(item, index) in qyry" :key="index"
							@click="selYear(index)">
							{{ item.year }}
						</li>
					</ul>
				</div>
				<p><i @click="handUp" class="hn_shang el-icon-arrow-up"></i></p>
				<p>
					<i @click="handDown" class="hn_xia el-icon-arrow-down"></i>
				</p>
			</div>
			<div class="hn_right">
				<div class="hnrt_con">
					<swiper class="hn_swiper" :options="swiperOptions">
						<swiper-slide class="hn_slide" v-for="(item, index) in qyry[actIndex].banner" :key="index">
							<img :src="staticImg + item.image" />
							<p class="hn_slide_p">{{ item.title }}</p>
						</swiper-slide>
						<div class="swiper-pagination pagination22" slot="pagination"></div>
						<div class="swiper-button-prev" slot="button-prev"></div>
						<div class="swiper-button-next" slot="button-next"></div>
					</swiper>
				</div>
			</div>
		</div>
		<div class="rd_box">
			<record></record>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			actIndex: 0,
			mtop: 0,
			swiperOptions: {
				// 分页器配置
				pagination: {
					el: ".pagination22",
					clickable: true,
				},
				// 导航按钮配置
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			},
			qyry: [],
			staticImg: this.$staticImg,
			scrollStep: 58
		};
	},
	created() {
		this.honor();
	},
	methods: {
		handUp() {
			const list = this.$refs.listRef;
			list.scrollTo({
				top: list.scrollTop - this.scrollStep,
				behavior: 'smooth'
			});
		},
		handDown() {
			const list = this.$refs.listRef;
			list.scrollTo({
				top: list.scrollTop + this.scrollStep,
				behavior: 'smooth'
			});
		},
		selYear(index) {
			this.actIndex = index;
		},
		// 企业荣誉
		async honor() {
			const res = await this.$api.honor();
			if (res.code == 1) {
				this.qyry = res.data;
			}
		},
	},
};
</script>

<style lang="scss">
.ho_act1 {
	color: #d43235 !important;
	font-size: 20px !important;
}

.pagination22 {
	bottom: 80px !important;
}
.honor {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	margin-top: 76px;
	width: 100%;
	padding: 106px 20px 80px;
	background-image: url("../../images/bgimg3.png");
	box-sizing: border-box;
	.hn_box {
		max-width: 1084px;
		min-width: 950px;
		margin: 0 auto;
		display: flex;
		align-items: flex-start;
		.hn_left {
			width: 72px;
			padding: 42px 0;
			height: 664px;
			overflow: hidden;
			position: relative;
			box-sizing: border-box;
			.hn_shang {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				z-index: 1;
				text-align: center;
				cursor: pointer;
				font-size: 20px;
				color: #666;
				font-weight: 600;
			}
			.hn_xia {
				position: absolute;
				left: 0;
				right: 0;
				text-align: center;
				cursor: pointer;
				bottom: 0;
				font-size: 20px;
				color: #666;
				font-weight: 600;
			}
			.hn_box {
                height: 100%;
				.hn_ul {
					width: 72px;
                    overflow-y: auto;
                    overflow: hidden;
                    height: 100%;
					.hn_li {
						font-weight: 700;
						text-align: center;
						height: auto;
						line-height: 58px;
						color: #505050;
						font-size: 18px;
						cursor: pointer;
					}
				}
			}
		}
		.hn_right {
			flex: 1;
			padding-left: 50px;
			overflow: hidden;
			.hnrt_con {
				box-sizing: border-box;
				background-color: #fff;
				background-image: url("../../images/about/bmg1.png");
				background-repeat: repeat-x;
				background-position: bottom;
				padding: 66px 75px;
				border-radius: 3px;
				min-height: 658px;
				.hn_swiper {
					width: 100%;
					height: 554px;
					.hn_slide {
						width: 100%;
						height: 554px;
						display: flex;
						justify-content: center;
						flex-wrap: wrap;

						img {
							height: 440px;
							max-width: 662px;
							width: auto;
						}
						.hn_slide_p {
							width: 662px;
							margin-top: 42px;
							font-size: 24px;
							color: #000;
							text-align: center;
							line-height: 1.5;
						}
					}
					.swiper-button-prev,
					.swiper-button-next {
						color: #999999;
					}
					.swiper-pagination-bullet-active {
						opacity: 1;
						background: #d43235 !important;
					}
				}
			}
		}
	}
	.rd_box {
		margin-top: 80px;
	}
}
</style>